// extracted by mini-css-extract-plugin
module.exports = {"lgMin":"992"};